import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getPaymentTrackingCode } from "../services/FinancialService";
import DashboardLayout from "./DashboardLayout";

const PaymentResult = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const status = params.get("status");
  const [trackingCode, setTrackingCode] = useState(null);
  const invoiceId = params.get("invoiceId");

  const isSuccess = status === "success";

   const returnPath =
    localStorage.getItem("paymentReturnTo") || "/unSettledInvoiceList";

  useEffect(() => {
    if (isSuccess && invoiceId) {
      getPaymentTrackingCode(invoiceId)
        .then((res) => {
          setTrackingCode(res.data.trackingCode);
        })
        .catch(() => {
          setTrackingCode(null);
        });
    }
  }, [isSuccess, invoiceId]);

   useEffect(() => {
    return () => {
      localStorage.removeItem("paymentReturnTo");
    };
  }, []);

  return (
    <DashboardLayout>
      <div className="max-w-md mx-auto bg-white shadow rounded-xl p-6 text-center mt-10">
        {isSuccess ? (
          <>
            <h2 className="text-green-600 text-lg font-bold mb-3">
              پرداخت با موفقیت انجام شد ✅
            </h2>
            <p className="text-sm text-gray-700 mb-2">
              شماره فاکتور: {invoiceId}
            </p>
            <p className="text-sm text-gray-700 mb-4">
              کد رهگیری بانکی:
              <span className="font-bold block mt-1">
                {trackingCode ?? "در حال دریافت..."}
              </span>
            </p>
            <div className="bg-green-50 border border-green-200 rounded-lg p-3 text-sm text-green-800 mb-4">
              پرداخت شما با موفقیت در سیستم ثبت شد و حداکثر تا
              <span className="font-bold"> 1 ساعت</span>
              آینده در فاکتور شما اعمال خواهد شد.
            </div>
          </>
        ) : (
          <>
            <h2 className="text-red-600 text-lg font-bold mb-3">
              پرداخت ناموفق ❌
            </h2>
            <p className="text-sm text-gray-600">
              در صورت کسر وجه، مبلغ به حساب شما بازمی‌گردد.
            </p>
          </>
        )}

        <button
          // onClick={() => navigate("/unSettledInvoiceList", { replace: true })}
          onClick={() => navigate(returnPath, { replace: true })}
          className="mt-6 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded"
        >
          بازگشت به فاکتورهای تسویه نشده
        </button>
      </div>
    </DashboardLayout>
  );
};

export default PaymentResult;
